import script from "./XTextarea.vue?vue&type=script&lang=ts&setup=true"
export * from "./XTextarea.vue?vue&type=script&lang=ts&setup=true"

import "./XTextarea.vue?vue&type=style&index=0&id=af4d285c&lang=css&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af4d285c"]])

export default __exports__